import {
    GET_GIFT_CARD,
    OPEN_GIFT_CARD_MODAL,
    CLOSE_GIFT_CARD_MODAL,
    UPDATE_GIFT_CARD,
    DELETE_GIFT_CARD,
    MARK_GIFT_CARD_AS_PRINTED,
    GENERATE_GIFT_CARDS
} from './giftCard.actionsTypes';

const patchUpdatedGiftCard = (gitCard, updates) => {
    if (!updates || 'object' !== typeof updates) {
        return gitCard;
    }
    for (let key in updates) {
        if (updates.hasOwnProperty(key)) {
            gitCard[key] = updates[key];
        }
    }
    return updates;
};

export default function giftCards(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
    case OPEN_GIFT_CARD_MODAL:
        return {
            ...newState,
            giftCard: action.giftCard || null,
            show: true
        };
    case CLOSE_GIFT_CARD_MODAL:
        return {
            ...newState,
            giftCard: null,
            show: false
        };
    case GET_GIFT_CARD:
        return {
            ...newState,
            giftCards: action.giftCards
        };
    case UPDATE_GIFT_CARD:
        newState.giftCards.forEach((giftCard) => {
            if (giftCard._id === action.giftCard._id) {
                patchUpdatedGiftCard(giftCard, action.giftCard);
            }
        });
        return newState;
    case DELETE_GIFT_CARD:
        let condition;
        if (action.options.id) {
            condition = (giftCard) => giftCard.cardId == action.options.id;
        } else if (action.options.price && action.options.creationDate) {
            condition = (giftCard) => giftCard.creationDate == action.options.creationDate &&
                giftCard.initialBalance == action.options.price;
        }
        newState.giftCards = newState.giftCards.map((giftCard) => {
            giftCard.status = condition(giftCard) ? 5: giftCard.status;
            return giftCard
        });
        return newState;
    case MARK_GIFT_CARD_AS_PRINTED:
        if (action.options.price && action.options.creationDate) {
            const condition = (giftCard) => giftCard.creationDate == action.options.creationDate &&
                giftCard.initialBalance == action.options.price;
            newState.giftCards = newState.giftCards.map((giftCard) => {
                giftCard.isPrinted = condition(giftCard) ? true : giftCard.isPrinted;
                return giftCard
            });
        }
        return newState;
    case GENERATE_GIFT_CARDS:
        return {
            ...newState,
            generatedCards: action.generatedCards
        };
    default:
        return newState;
    }
}